import styles from './accordion.module.css'

export const statesIcon: Record<'open' | 'close', string> = {
  open: styles['icon-state-open'],
  close: '',
}

export const generateClassesOfIcon = (isActive: boolean) => {
  return `${styles['icon-core']} ${isActive ? styles['icon-state-open'] : ''}`
}
